// @core/api/endpoints/billing/finalize_invoice.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FinalizeInvoiceRequest,
  FinalizeInvoiceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Finalize invoice (assign number, prevent edits)
 * Finalizes a draft invoice, assigning an invoice number and locking it for editing. Optionally sends the invoice to the customer automatically.
 */
export async function FinalizeInvoice(
  id: string,
  data: FinalizeInvoiceRequest,
  options?: RequestOptions
): Promise<FinalizeInvoiceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invoices/:id/finalize`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<FinalizeInvoiceResponse>(requestPath, data, requestOptions);
}
